import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    effect,
    ElementRef, ErrorHandler,
    Inject,
    inject,
    OnDestroy,
    OnInit, signal,
    viewChild,
    ViewEncapsulation
} from '@angular/core';
import {DOCUMENT, NgForOf, NgIf} from '@angular/common';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule} from "@angular/forms";
import {SnackbarService} from "@serv/snackbar.service";
import {MatTooltip} from "@angular/material/tooltip";
import {DataService} from '@serv/data.service';
import {Subject, Subscription, takeUntil} from "rxjs";
import {JsonExtractorService} from "@llm/service/json-extractor.service"
import {Llm_ShortcutService} from '@llm/service/llm_shortcut.service';
import {BotResponseService} from '@llm/service/chat_history.service';
import {MatTableDataSource} from '@angular/material/table';
import {currentContext, UserChatMessage} from '@llm/interfaces/interfaces_to_main_component';
import {MessageService} from '@llm/service/message.service';
import {SpeechSynthesizerService} from '@llm/service/speech_synthesizer.service';
import {VoiceCommandService} from '@llm/service/voice_command.service';
import {SpeechRecognitionService} from '@llm/service/speech_recognition.service';
import {AudioRecordingService} from "@llm/service/audio_recording.service";
import {PlayMessageService} from "@llm/service/play_message.service";
import {LlmLoggingService} from '@llm/service/llm-logging.service';
import {AudioTranscriptionService} from '@llm/service/audio_transciption.service';
import {ChatUIService} from '@llm/service/chat_ui.service';
import {VoiceCommand, VoiceCommandActionsService} from '@llm/service/voice_command_actions.service';
import {UiStateService} from '@llm/service/signals_ui_state.service';
import {llmStoreService, RecordingStatus as RecordingStatus} from '@llm/service/llm_store.service';
import {ToolsAiDialogsService} from '@llm/service/tools_ai-dialogs.service';
import {Tools_aiConsoleService} from '@llm/service/tools_ai-console.service';
import {ToolsAiStorageService} from '@llm/service/tools-ai-storage.service';
import {ThemePalette, ToolsAiThemeService} from '@llm/service/tools_ai_theme.service';
import {DevicePermissionsService} from '@serv/media_access/devices_permissions.service';
import {VEHICLE_PLATE_REGEX} from '@llm/utils/response_regex_for_streaming';
import {AppVisibilityService} from '@serv/media_access/app_visibility.service';
import {LlmInferenceService} from '@llm/service/llm_together_ai.service';
import { MarkdownComponent } from 'ngx-markdown';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {SearchWebInfoTool} from "@llm/models/schemas/agents/search_info/searchWebInfo.service";
import {CustomErrorHandler} from "@llm/service/custom-error-handler";
import {DragDropModule, CdkDragEnd} from '@angular/cdk/drag-drop';
import {STORAGE_KEYS} from '@class/storage-keys';

/**
 * @Component Decorador que marca la clase como un componente Angular y configura sus metadatos.
 * selector: 'mkg-main-wdgt' - El nombre de la etiqueta HTML personalizada para este componente.
 * standalone: true - Indica que el componente es autocontenido y gestiona sus propias dependencias.
 * imports: [...] - Módulos y otros componentes que este componente utiliza.
 * templateUrl: './main-wdgt.component.html'
 * styleUrl: './main-wdgt.component.scss'
 * encapsulation: ViewEncapsulation. None - Desactiva la encapsulación de estilos, los estilos serán globales.
 */
@Component({
  selector: 'mkg-main-wdgt',
  standalone: true,
  imports: [MatMenuModule, MatButtonModule, MatIconModule, FormsModule, MatTooltip, NgIf, NgForOf, CommonModule, MarkdownComponent,  BrowserAnimationsModule, DragDropModule],
  templateUrl: './main-wdgt.component.html',
  styleUrls: ['./main-wdgt.component.scss', './main-wdgt.responsive.component.scss', './micelanius-main-wdgt.scss'],
  encapsulation: ViewEncapsulation.None,//estricto
  changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('expandContent', [
            state('normal', style({
                width: '350px',
                height: '500px'
            })),
            state('expanded', style({
                width: '80vw',
                height: '90vh'
            })),
            transition('normal <=> expanded', [
                animate('1.9s ease-in-out')
            ])
        ])
    ],
    providers:[
        { provide: ErrorHandler, useClass: CustomErrorHandler }
    ]
})
export class MainWdgtComponent implements OnInit, AfterViewInit, OnDestroy {
  // --- INYECCIÓN DE DEPENDENCIAS ---
  store = inject(llmStoreService);
  protected toolsAiDialogsService = inject(ToolsAiDialogsService);
  protected _snackbarService = inject(SnackbarService);
  protected chatUIService = inject(ChatUIService);
  protected audioRecordingService = inject(AudioRecordingService);
  private _speechSynthesizerService = inject(SpeechSynthesizerService);
  private _voiceCommandService = inject(VoiceCommandService);
  //private agentSaveDataService = inject(AgentSaveDataService);
  private _messageService = inject(MessageService);
  private _speechRecognitionService = inject(SpeechRecognitionService);
  private _audioTranscriptionService = inject(AudioTranscriptionService);
  private data_service = inject(DataService);
  private jsonExtractor = inject(JsonExtractorService);
  private shortcutService = inject(Llm_ShortcutService);
  //private llm_service = inject(LlmStudioService);
  private voiceCommandActions = inject(VoiceCommandActionsService);
  private botResponseService = inject(BotResponseService);
  private playMessageService = inject(PlayMessageService);
  private uiState = inject(UiStateService);
  private _console = inject(Tools_aiConsoleService);
  private _toolsAiStorageService = inject(ToolsAiStorageService);
  private _themeService = inject(ToolsAiThemeService);
  private elementRef = inject(ElementRef);
  private _devicePermissionsService = inject(DevicePermissionsService);
  private _appVisbilitySvc = inject(AppVisibilityService);
  private _infenrenceService = inject(LlmInferenceService);
  private _toolSearchWebInfo= inject(SearchWebInfoTool);
  private _llmLoggingService = inject(LlmLoggingService);
  get state() {
    return this.uiState;
  }

  chatsRef = viewChild<ElementRef<HTMLDivElement>>('chats');
  widgetRef = viewChild<ElementRef<HTMLDivElement>>('widget');
  profileDivRef = viewChild<ElementRef<HTMLDivElement>>('profileDiv');
  imgAnimatedRef = viewChild<ElementRef<HTMLImageElement>>('imgAnimated');
  imgStaticRef = viewChild<ElementRef<HTMLImageElement>>('imgStatic');
  textAreaUserInputRef = viewChild<ElementRef<HTMLTextAreaElement>>('text_area_user_input');
  sendButtonRef = viewChild<ElementRef<HTMLButtonElement>>('sendButton');
  ToolsAiHeadertooltipRef = viewChild<MatTooltip>('ToolsAiHeadertooltip');

  //public isExpandedForComplexContent = signal<boolean>(false)

  /**
   * Posición (top/left en px, relativos al viewport) a la que el usuario arrastró
   * el ícono flotante de Gloria. `null` mientras se usa la posición por defecto
   * definida en el SCSS (bottom/right).
   */
  profilePosition = signal<{ top: number; left: number } | null>(this.loadProfilePosition());


//Variable de control provicional para no renderizar mensaje del llm despues la busqueda web con llm
  isRenderMessageForContent: boolean = true;

  /** Almacena el nombre del agente LLM actualmente activo. */
  agent_actually = '';
  /** Indica si ha ocurrido un error durante el streaming de la respuesta del LLM. */
  error_status_stream: boolean;
  /** Almacena el token o fragmento de texto más reciente recibido del LLM durante el streaming. */
  token_actually = '';
  /** Array para almacenar los objetos JSON extraídos de las respuestas del LLM. */
  extractedJSONs: any[] = [];
  /** Pila para gestionar los contextos de conversación con múltiples agentes LLM. */
  private contextStack: currentContext[] = [];

  /** Array para almacenar las funciones de cancelación de registro de los atajos de teclado. */
  private unregisterFunctions: (() => void)[] = [];
  /**
   * Bandera para decidir qué método de transcripción de audio se utilizará.
   * true: Utiliza AssemblyAI para la transcripción.
   * false: Utiliza la API de reconocimiento de voz del navegador (Web Speech API).
   */
  private useAssemblyAI: boolean = true;
  /** Propiedades para la tabla a renderizar (actualmente no se usa en la plantilla,
   * pero se define para futuros usos)
   * Columnas que se mostrarán en la tabla.
   */
  displayedColumns: string[] = [];
  /** Fuente de datos para la tabla de Angular Material. */
  dataSource = new MatTableDataSource<any>([]);
  /** Bandera para controlar si se ha recibido el primer fragmento de la respuesta del LLM. */
  firstResponseReceived = false;
  /** Almacena la respuesta completa del LLM que se va construyendo a partir de los fragmentos. */
  responseReceived: string = '';
  /** Vinculado al textarea donde el usuario escribe su mensaje. */
  userText: string = '';
  /** TODO: Variable para una instancia de gráfico en el chat (actualmente no se usa). */
  chatChart: any = undefined;
  /** Variable para una instancia de gráfico en un modal (actualmente no se usa). */
  modalChart: any = undefined;
  /** Indica si el usuario ha concedido permiso para la entrada. */
  permission_entry: boolean = true;
  /** Almacena la transcripción de voz obtenida del navegador o AssemblyAI. */
  transcript: string = '';
  /** Historial de mensajes del chat. */
  chat_history: UserChatMessage[] = [];
  chat_audio_history: UserChatMessage[] = [];
  message_header_widget: string = '';

  pila_agentes_pendientes: []


  /** Indica si ya se ha realizado una grabación (para evitar envíos múltiples o vacíos). */
  completedRecorded: boolean = false;
  /** Suscripción a observables para gestionar su ciclo de vida. */
  private subscription!: Subscription;
  private voiceCommandServiceSub?: Subscription;
  private destroy$ = new Subject<void>();
  private speechSynthesizerSubscription: Subscription | undefined;
  private mediaRecordingIntent: boolean = false;

  private userTextChanges = new Subject<string>();


  /**
   * Constructor del componente.
   * Inyecta los servicios necesarios para la funcionalidad del widget.
   * Configura la API de reconocimiento de voz del navegador si está disponible.
   *
   * @param document Referencia al objeto `document` del DOM.
   */
  constructor(@Inject(DOCUMENT) private document: Document) {
    this._llmLoggingService.info('MainWdgtComponent inicializado', {}, 'MainWdgtComponent', 'constructor');


    this.chatUIService.messageToSend.pipe(
      takeUntil(this.destroy$)
    ).subscribe(transcript => {
      this.send(transcript);
    });

      effect(() => {
          //store.isSpeaking() || store.isProcessingAudio() || store.isProcessingText()
         this._console.log("store.isProcessingText() =>", this.store.isProcessingText())
         this._console.log("store.isSpeaking() =>", this.store.isSpeaking())
         this._console.log("store.isProcessingAudio() =>", this.store.isProcessingAudio())
         this._console.log("Resultado =>", (this.store.isProcessingAudio() || this.store.isProcessingText() || this.store.isSpeaking()))
          if(this.store.action_instant() =='Pesquisando informações online'){
              this.store.isExpandedForComplexContent.update(()=>true)
          }
          if(this._toolSearchWebInfo.tools_call_search_web_markdown_info()){
              this.isRenderMessageForContent=false;
              this.chatUIService.handleBotComplexResponse(this._toolSearchWebInfo.tools_call_search_web_markdown_info())
              this._toolSearchWebInfo.tools_call_search_web_markdown_info.update(() => null)

          }

      }, {allowSignalWrites: true});

    effect(() => {
      const settings = this.store.settingsToolsAi()
      this._console.log('settings:', settings);
      const theme: ThemePalette = this._themeService.getColorsByThemeName(settings.theme);
      this._console.warn(`[main-wdgt]Tema alterado para: ${theme.colors.primary}`);
      this.elementRef.nativeElement.style.setProperty('--tools-ai-theme-ui', theme.colors.primary)
      this.elementRef.nativeElement.style.setProperty('--tools-ai-theme-ui-box-shadow', theme.colors.boxShadow)
    })

    /**
     * Configura um listener para o estado de fala do SpeechSynthesizerService.
     * Pausa o MediaRecorder quando o sistema começa a falar e retoma quando termina.
     */
    effect(() => {
      if (this.store.isSpeaking()) { // Acessa o valor da sinal global `isSpeaking`
        if (this.store.isRecording() && this.store.recordingStatus() === RecordingStatus.RECORDING) {
          this._console.log('MainComponent: Pausando MediaRecorder devido à voz do sistema.');
          this.audioRecordingService.pauseRecording();
        }
      } else { // Usa `isMicrophoneReady()` para garantir que o microfone esteja pronto
        if (this.audioRecordingService.isMicrophoneReady()) { // Adicionado verificação de prontidão do microfone
          if (this.mediaRecordingIntent && this.store.recordingStatus() === RecordingStatus.PAUSED) {
            this._console.log('MainComponent: Reanudando MediaRecorder após a voz do sistema.');
            this.audioRecordingService.resumeRecording();
          } else if (this.mediaRecordingIntent && !this.store.isRecording() && this.store.recordingStatus() === RecordingStatus.INACTIVE) {
            this._console.log('MainComponent: Tentando reiniciar MediaRecorder após voz do sistema e estado inativo.');
            this.audioRecordingService.startRecording();
          }
        } else {
          this._console.warn('MainComponent: Microfone não está pronto para retomar/iniciar gravação.');
        }
      }
    }, {allowSignalWrites: true});

    effect(() => { // Effect para reagir quando o elemento 'chats' estiver disponível ou indisponível
      const chatsElementRef = this.chatsRef()
      if (chatsElementRef) {
        this._console.log('Component: "chats" element is now rendered.', chatsElementRef.nativeElement);
        this.chatUIService.setChatContainer(chatsElementRef.nativeElement);
      } else {
        this._console.log('Component: "chats" element is no longer rendered.');
        this.chatUIService.setChatContainer(null)
      }
    }, {allowSignalWrites: true});

    effect(() => { // Effect para reagir quando o elemento 'widget' estiver disponível ou indisponível
      const widgetElementRef = this.widgetRef();
      if (widgetElementRef) {
        this._console.log('Component: "widget" element is now rendered.', widgetElementRef.nativeElement);
        this.chatUIService.setWidgetElement(widgetElementRef.nativeElement);
      } else {
        this._console.log('Component: "widget" element is no longer rendered.');
        this.chatUIService.setWidgetElement(null);
      }
    }, {allowSignalWrites: true});

    effect(() => { // Effect para reagir quando o elemento 'profileDiv' estiver disponível ou indisponível
      const profileDivElementRef = this.profileDivRef();
      if (profileDivElementRef) {
        this._console.log('Component: "profileDiv" element is now rendered.', profileDivElementRef.nativeElement);
        this.chatUIService.setProfileDivElement(profileDivElementRef.nativeElement);
      } else {
        this._console.log('Component: "profileDiv" element is no longer rendered.');
        this.chatUIService.setProfileDivElement(null);
      }
    }, {allowSignalWrites: true});

    effect(() => { // Effect para reagir quando o elemento 'imgAnimated' estiver disponível ou indisponível
      const imgAnimatedElementRef = this.imgAnimatedRef();
      if (imgAnimatedElementRef) {
        this.chatUIService.setImgAnimatedElement(imgAnimatedElementRef.nativeElement);
        this._console.log('Component: "imgAnimated" element is now rendered.', imgAnimatedElementRef.nativeElement);
      } else {
        this.chatUIService.setImgAnimatedElement(null);
        this._console.log('Component: "imgAnimated" element is no longer rendered.');
      }
    }, {allowSignalWrites: true});

    effect(() => { // Effect para reagir quando o elemento 'imgStatic' estiver disponível ou indisponível
      const imgStaticElementRef = this.imgStaticRef();
      if (imgStaticElementRef) {
        this.chatUIService.setImgStaticElement(imgStaticElementRef.nativeElement);
        this._console.log('Component: "imgStatic" element is now rendered.', imgStaticElementRef.nativeElement);
      } else {
        this.chatUIService.setImgStaticElement(null);
        this._console.log('Component: "imgStatic" element is no longer rendered.');
      }
    }, {allowSignalWrites: true});

    effect(() => { // Effect para o input da área de texto do usuário
      const textAreaRef = this.textAreaUserInputRef();
      if (textAreaRef) {
        this.chatUIService.setUserTextArea(textAreaRef.nativeElement);
        this._console.log('Component: "text_area_user_input" is now rendered.');
      } else {
        this.chatUIService.setUserTextArea(null);
        this._console.log('Component: "text_area_user_input" is no longer rendered.');
      }
    }, {allowSignalWrites: true});

    effect(() => { // Effect para capturar o botão de enviar @deprecado actualmente aunque funcional
      if (this.sendButtonRef()) {
        this.chatUIService.setSendButton(this.sendButtonRef().nativeElement);
        this._console.log('Component: "sendButton" is now rendered.');
      } else {
        this.chatUIService.setSendButton(null);
        this._console.log('Component: "sendButton" is no longer rendered.');
      }
    }, {allowSignalWrites: true});

    effect(() => { // Atualiza o sinal de gravação do UI
      if (this.store.recordingStatus() === RecordingStatus.RECORDING) {
        this.state.startRecording();
      } else if (this.store.recordingStatus() === RecordingStatus.INACTIVE) {
        this.state.stopRecording();
      }
    }, {allowSignalWrites: true});

    effect(() => { //Effect disenado para limpiar text area cuando se cierra el chat
      if (!this.store.isShowChat()) {
          this.userText = '';
          this.audioRecordingService.stopRecording();
          this.contextStack.pop(); // Volver al contexto del agente 'main'
          this.store.setAgentExtracted(-1)
          this.chat_history.length = 0;
          this.store.isExpandedForComplexContent.update(()=> false)
          this.isRenderMessageForContent=true
          this._infenrenceService.clearHistory();
          //this.llm_service.setCurrentAgent('main')
          if (this.store.isProcessingAudio()) {
              this.store.isProcessingAudio.set(false);
          }
          this.completedRecorded = false; // TODO: Revisar esto, es critico  y podria dar problemas futuros
      } else { //Alternativa => this.userText =  this.store.isShowChat()?this.userText:''
        if (this.textAreaUserInputRef() && this.textAreaUserInputRef().nativeElement) {
          this.textAreaUserInputRef().nativeElement.focus();
        }
      }
    }, {allowSignalWrites: true});

    effect(() => { //Control de desabilitacion de botones de envio y grabación de audio
      if (this.sendButtonRef() && this.sendButtonRef().nativeElement) {
        this.sendButtonRef().nativeElement.disabled = this.store.isSpeaking() || this.store.isProcessingAudio() || this.store.isProcessingText();
      }
      if (this.textAreaUserInputRef() && this.textAreaUserInputRef().nativeElement) {
        // this.textAreaUserInputRef().nativeElement.disabled = this.store.isSpeaking() || this.store.isProcessingAudio() || this.store.isProcessingText();
      }
    });
  }

  ngOnInit() {
    this._llmLoggingService.info('MainWdgtComponent ngOnInit: inicializando suscripciones', {}, 'MainWdgtComponent', 'ngOnInit');

    this.audioRecordingService.audioBlob$.subscribe(blob => { // Suscrição para o estado de gravação do serviço de gravação de áudio
      this.setUserResponse(blob);
    });

    this.playMessageService.onMessagePrint.subscribe(messageObject => {
        if (this.isRenderMessageForContent){
            this.chatUIService.handleBotResponse(messageObject);
        }else{
            this.isRenderMessageForContent=true
        }

    });

    // this.llm_service.currentAgent$.subscribe(valor => { // Suscreve a mudanças no agente LLM ativo.
    //   this.agent_actually = valor;
    // });
    //
    // this.llm_service.errorStreamStatus$.subscribe(valor => { // Suscreve a mudanças no estado de erro do stream do LLM.
    //   this.error_status_stream = valor;
    // });

    this.registerKeyboardShortcuts(); // Registrar os atalhos de teclado.

    this.voiceCommandServiceSub = this._voiceCommandService.commandDetected // Suscreve a detecção de comandos de voz.
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (command: string) => {
          this.executeAction(command);
        },
        error: (error: any) => {
          this._console.error('Erro na detecção de comandos:', error);
        },
        complete: () => {
          this._console.log('O serviço de detecção de comandos de voz foi concluído.');
        }
      });
    // this.botResponseService.botResponse$.subscribe(() => { // Subscrição do botResponseService movida para ngOnInit
    //   this.chatUIService.scrollToBottom();
    // });
  }

  ngAfterViewInit() {
    this._llmLoggingService.info('MainWdgtComponent ngAfterViewInit: vista inicializada', {}, 'MainWdgtComponent', 'ngAfterViewInit');
    this.clearTextArea();
    this.handleVirtualKeyboard();
    this.botResponseService.botResponse$.subscribe(() => { // Cuando el bot responde, hace scroll hasta el final del chat.
      this.chatUIService.scrollToBottom();
    });
    setTimeout(() => { //TODO: dicutir con Mario sobre estos elementos a ejecutar en los primero segundos
    }, 10000);
  }

  /**
   * Hook del ciclo de vida de Angular. Se ejecuta justo antes de que Angular destruya el componente.
   * Limpia suscripciones y cancela el registro de atajos de teclado para prevenir fugas de memoria.
   */
  ngOnDestroy() {
    this._llmLoggingService.info('MainWdgtComponent ngOnDestroy: destruyendo componente y limpiando recursos', {}, 'MainWdgtComponent', 'ngOnDestroy');
    this.unregisterFunctions.forEach(unregister => unregister()); // Cancela o registro de todos os atalhos de teclado.
    this.unregisterFunctions = [];
    if (this.subscription) { // Cancela a assinatura a `commandDetected`.
      this.subscription.unsubscribe();
    }
    if (this.voiceCommandServiceSub) {
      this.voiceCommandServiceSub.unsubscribe();
    }
    if (this.speechSynthesizerSubscription) {
      this.speechSynthesizerSubscription.unsubscribe();
    }
    if (this.store.recordingStatus() !== RecordingStatus.INACTIVE) {// Usa o sinal `recordingState()` diretamente
      this.audioRecordingService.stopRecording();
      this.audioRecordingService.stopDestroy();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Se ejecuta cuando el usuario termina de arrastrar el ícono flotante de Gloria.
   * Convierte el desplazamiento libre de `cdkDrag` en una posición fija (top/left)
   * acotada al viewport actual, la persiste en `localStorage` y resetea el offset
   * interno de `cdkDrag` para que un próximo arrastre no se acumule sobre el anterior.
   */
  onProfileDragEnded(event: CdkDragEnd): void {
    const element = event.source.getRootElement();
    const rect = element.getBoundingClientRect();
    const position = this.clampPosition(rect.top, rect.left, rect.width, rect.height);

    this.profilePosition.set(position);
    event.source.reset();
    this.saveProfilePosition(position);
  }

  private clampPosition(top: number, left: number, width: number, height: number): { top: number; left: number } {
    const maxLeft = Math.max(0, window.innerWidth - width);
    const maxTop = Math.max(0, window.innerHeight - height);
    return {
      top: Math.min(Math.max(top, 0), maxTop),
      left: Math.min(Math.max(left, 0), maxLeft)
    };
  }

  private loadProfilePosition(): { top: number; left: number } | null {
    if (typeof localStorage === 'undefined' || typeof window === 'undefined') {
      return null;
    }
    const raw = localStorage.getItem(STORAGE_KEYS.GLORIA_WIDGET_POSITION.key);
    if (!raw) {
      return null;
    }
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed?.top !== 'number' || typeof parsed?.left !== 'number') {
        return null;
      }
      // Tamaño aproximado del ícono (ver clamp() en main-wdgt.component.scss) usado como
      // margen de seguridad, ya que el elemento todavía no está renderizado en este punto.
      return this.clampPosition(parsed.top, parsed.left, 150, 150);
    } catch {
      return null;
    }
  }

  private saveProfilePosition(position: { top: number; left: number }): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    localStorage.setItem(STORAGE_KEYS.GLORIA_WIDGET_POSITION.key, JSON.stringify(position));
  }

  clearTextArea() {
    this.userText = '';
    if (this.textAreaUserInputRef()?.nativeElement?.value) {  // Usa `textAreaUserInputRef()` para acessar o elemento
      this.textAreaUserInputRef().nativeElement.value = '';
    }
  }

  onUserTextInput(): void {
    this.userTextChanges.next(this.textAreaUserInputRef()?.nativeElement?.value || '');// Usa `textAreaUserInputRef()` para acessar o elemento
    if (!this.textAreaUserInputRef()?.nativeElement?.value) {
      this.store.setUserTypingText(false);
    } else {
      this.store.setUserTypingText(true);
    }
  }


  private executeAction(command: string): void {
    if (this.isValidCommand(command)) {
      this.voiceCommandActions.executeAction(command as VoiceCommand);
    } else {
      this._console.warn(`Comando inválido: ${command}`);
    }
  }

  private isValidCommand(command: string): command is VoiceCommand {
    return [
      'OpenChatNitro',
      'FechouGrab',
      'FecharChat',
      //'SilentVoiceUser'
    ].includes(command);
  }


  setUserResponse(message: string | Blob) {
    this._console.log('Llamando a la funcion......')
    if (typeof message === 'string' && this.state._isRenderedTranscription() != '' && message != this.state._isRenderedTranscription()) {

    }
    const userMessage = this.chatUIService.handleUserResponse(message);

    this._console.log('userMessage:', userMessage);

    if (typeof message === 'string') {
      if (this.contextStack.length > 0) {
        this.contextStack[this.contextStack.length - 1].chatHistory.push(
          {role: 'user', content: message as string}
        );
      } else {
        this.chat_history.push({
          role: 'user',
          content: message as string,
          timestamp: new Date()
        });
      }
    } else {
      this.chat_audio_history.push(userMessage);
      this.chatUIService.transcribeAndUpdateUI(userMessage);
    }

    //this.chatUIService.showTypingIndicator();
  }

  setBotResponse(response: string | null) {
      if(this.isRenderMessageForContent){
          this.chatUIService.handleBotResponse({content:response, id:'undefined'});
      }else{
          this.isRenderMessageForContent=true
      }

  }


  clearChat() {
    this.chatUIService.clearChat();
    this.chat_history = [];
    this.contextStack = [];
    this._infenrenceService.clearHistory();
    //this.llm_service.setCurrentAgent('main');
  }

  /**
   * Reinicia el chat. TODO:Actualmente no tiene implementación.
   */
  restartChat() {
    this.clearChat(); // Por ahora, llama a clearChat.
    this._console.log("Chat reiniciado.");
  }

  /**
   * Acciones a realizar antes de enviar un mensaje al LLM.
   * Destruye gráficos existentes y elimina elementos dinámicos de la UI.
   */
  pre_send() {
    this.destroyChart();
    this.chatUIService.removeElementsByClass(['suggestions', 'paginated_cards', 'quickReplies', 'dropDownMsg']);
    this._console.log("Preparativos pre-envío completados.");
  }

    private pre_send_text_processing(text: string) {
        return text.replace(VEHICLE_PLATE_REGEX, match => match.toUpperCase());
    }

  /**
   * Lógica principal para enviar mensajes al LLM y gestionar la conversación multi-agente.
   * Utiliza una pila de contextos (`contextStack`) para manejar el flujo entre diferentes agentes.
   *
   * @param entry Texto opcional a enviar. Si no se provee, asumimos que el flujo continúa desde un agente.
   */
  async send(entry?: string) {
      this.store.isProcessingText.set(true);
      if (entry) {
          this.setUserResponse(this.pre_send_text_processing(entry));
          this.clearTextArea();
      }
      this.chatUIService.showTypingIndicator();
      // Contexto actual
      let currentContext = this.contextStack.length > 0
          ? this.contextStack[this.contextStack.length - 1]
          : {
              activeAgent: 'main',
              pendingAgents: [],
              chatHistory: [...this.chat_history]
          };
      //this.llm_service.setCurrentAgent(currentContext.activeAgent);
      this._llmLoggingService.info(`Enviando mensaje al agente: ${currentContext.activeAgent}`, {
        messageContent: currentContext.chatHistory[currentContext.chatHistory.length-1].content,
        activeAgent: currentContext.activeAgent
      }, 'MainWdgtComponent', 'send');

      try {
          const regex = /ID:\s*[a-f0-9]{24}\./;
          const responseText = await this._infenrenceService.sendMessage(currentContext.chatHistory[currentContext.chatHistory.length-1]);
          const botMessageId = `bot-msg-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
          this._llmLoggingService.info('Respuesta LLM recibida', { responseText }, 'MainWdgtComponent', 'send');

          this._console.log('Respuesta LLM:', responseText);
          let response: any;
          response = {
              voice_message: {
                id: botMessageId,
                content: responseText
              }
          };
          // try {
          //     this.extractedJSONs = this.jsonExtractor.extractJSON(responseText);
          //     response = this.extractedJSONs[0] || { voice_message: responseText };
          // } catch (err) {
          //     this._console.error('Error parseando respuesta:', err);
          //     response = { voice_message: responseText };
          // }

          // Reproducir audio si existe
          if (response.voice_message) {
              await this.playMessageService.playMessage(response.voice_message, true);
          }

          // Guardar en historial
          currentContext.chatHistory.push({
              role: 'assistant',
              content: response.voice_message || responseText,
              agente: currentContext.activeAgent
          });

      } catch (err) {
          this._llmLoggingService.error('Error en la comunicación con el LLM', err, {
            activeAgent: currentContext.activeAgent,
            lastUserMessage: currentContext.chatHistory[currentContext.chatHistory.length-1].content
          }, 'MainWdgtComponent', 'send');
          this._console.error('Error en sendMessage:', err);
         let  provisorio = {
              voice_message: {
                  id: 'undefined',
                  content: "Ocurrió un error al comunicarse con el servicio. Intente nuevamente."
              }
          }
          await this.playMessageService.playMessage(
              provisorio.voice_message,
              true
          );
      } finally {
          this.chatUIService.hideTypingIndicator();
          this.store.isProcessingText.set(false);
      }
  }


    /**
   * Actualiza el historial de chat global (`this.chat_history`) con los mensajes de una conversación.
   * Evita duplicados basados en contenido y rol.
   * @param newMessages Array de mensajes para agregar al historial global.
   * TODO:Revisar pues la logica no contempla ciertos casos[Añade el mensaje solo si no existe uno idéntico en el historial global.]
   */
  private updateGlobalChatHistory(newMessages: any[]) {
    newMessages.forEach(msg => {
      if (!this.chat_history.some(existingMsg => existingMsg.content === msg.content && existingMsg.role === msg.role)) {
        this.chat_history.push(msg);
        //this._infenrenceService.messagesHistory.update((prev)=>({...prev, msg}))
      }
    });
    this._console.log('Historial global de chat actualizado:', this.chat_history);
  }

  sendMessage($event?: any) {
    let message = this.textAreaUserInputRef().nativeElement.value;
    if (this.store.isProcessingText() || !message) {
      $event.preventDefault();
      return;
    }
    this.store.isProcessingText.set(true)
    this._console.log('Ejecutado sendMessage:', $event);
    this.textAreaUserInputRef().nativeElement.value = ''; // Limpa o textarea
    this.store.isUserTypingText.set(false);

    if ($event && !$event.shiftKey) {
      $event.preventDefault();
    }
    if (message.trim()) {
      this.pre_send();
      this.permission_entry = !this.permission_entry;
      if (this.contextStack.length > 0) {
        const currentAgent = this.contextStack[this.contextStack.length - 1].activeAgent;
        //this.llm_service.setCurrentAgent(currentAgent);
      }
      this.send(message);//this.chatUIService.handleUserResponse(message);
    }
  }


  /**
   * Destruye instancias de gráficos (Chart.js) si existen.
   * También elimina el contenedor del gráfico del DOM.
   * TODO: Considerar si esta funcionalidad de gráficos sigue siendo relevante.
   */
  destroyChart() {
    if (typeof this.chatChart !== 'undefined') {
      this.chatChart.destroy();
    }
    if (typeof this.modalChart !== 'undefined') {
      this.modalChart.destroy();
    }
    this.chatUIService.removeElementsByClass(['chart-container']);
    if (this.chatChart && typeof (this.chatChart as any).destroy === 'function') {
      (this.chatChart as any).destroy();
      this.chatChart = undefined;
    }
    if (this.modalChart && typeof (this.modalChart as any).destroy === 'function') {
      (this.modalChart as any).destroy();
      this.modalChart = undefined;
    }

  }

  handleVirtualKeyboard() {
    if (this.textAreaUserInputRef()) {
      this.textAreaUserInputRef().nativeElement.addEventListener('focus', () => {
        setTimeout(() => this.chatUIService.scrollToBottom(), 300);
      });
    }
  }


  protected handleInteractionButtonClick(): void {
    this._llmLoggingService.info('Botón de interacción clickeado', {
      isRecording: this.store.isRecording(),
      showMicrophoneIcon: this.state.showMicrophoneIcon(),
      isMicrophoneAccessGranted: this.store.isMicrophoneAccessGranted(),
      isUserTypingText: this.store.isUserTypingText(),
      showSendButton: this.state.showSendButton()
    }, 'MainWdgtComponent', 'handleInteractionButtonClick');

    if (this.store.isRecording()) {
      this._llmLoggingService.info('Deteniendo grabación por click de usuario', {}, 'MainWdgtComponent', 'handleInteractionButtonClick');
      this.audioRecordingService.stopRecording()
    } else if (this.state.showMicrophoneIcon()) {
      this._llmLoggingService.info('Iniciando grabación por click de usuario', {}, 'MainWdgtComponent', 'handleInteractionButtonClick');
      this.audioRecordingService.startRecording()
    } else if (!this.store.isMicrophoneAccessGranted() && this.store.settingsToolsAi().voiceInteractionEnabled && !this.store.isUserTypingText()) {

      if (this.store.isNotMicSupported()) {
        this._snackbarService.error("AUDIOS.SPEECH_TO_TEXT_BROWSER_UNSUPORTED_ERROR");
        return;
      }

      if (!this.store.isMicrophoneAccessGranted()) {
        this._devicePermissionsService.checkMicrophonePermission().then(state => {
          if (state == 'granted') {
            this.audioRecordingService.startRecording();
          } else if (state == 'denied') {
            this.audioRecordingService.requestPermission();
            this._snackbarService.error("PERMISSÃO_NEGADA_PARA_MICROFONE_NO_NAVEGADOR");
          } else if (state == 'prompt') {
            this.audioRecordingService.requestPermission();
            this._snackbarService.info("SOLICITAÇÃO_DE_PERMISSÃO_PARA_MICROFONE_NO_NAVEGADOR");
          } else if (state == 'unsupported') {
            this._snackbarService.error("ERRO_DE_MICROFONE_NÃO_SUPORTADO_NO_NAVEGADOR");
          }
        });
        return;
      }
    } else if (this.state.showSendButton()) {
      this.sendMessage()
    }
  }

  /**
   * Registra los atajos de teclado para abrir el chat e iniciar/detener la grabación.
   */
  private registerKeyboardShortcuts() {
    if (!this.store.isInteractionVoiceIntentStatus()) {
      return;
    }
    const shortcutConfig = this.store.settingsToolsAi().interactionShortcut;
    const shortcutString = this.buildShortcutString(shortcutConfig);
    const unregisterOpen = this.shortcutService.registerShortcut(
      shortcutString, // Combinación de teclas.
      [this.openAndStartRecording.bind(this)], // Array de funciones a ejecutar.
      1 // Prioridad alta
    );
    const unregisterStop = this.shortcutService.registerShortcut( // Atajo para detener la grabación (Alt+J).
      shortcutString,
      [this.audioRecordingService.stopRecording.bind(this)]
    );
    this.unregisterFunctions.push(unregisterOpen, unregisterStop); // Almacena las funciones de cancelación para llamarlas en `ngOnDestroy`.
  }

  /**
   * Construye una cadena de texto para el atajo a partir de un objeto de configuración.
   * @param shortcut El objeto que contiene la configuración del atajo.
   * @returns Una cadena de texto formateada como 'Ctrl+Shift+V'.
   */
  private buildShortcutString(shortcut: { key: string; altKey: boolean; ctrlKey: boolean; shiftKey: boolean }): string {
    const parts: string[] = [];

    if (shortcut.ctrlKey) {
      parts.push('Ctrl');
    }
    if (shortcut.shiftKey) {
      parts.push('Shift');
    }
    if (shortcut.altKey) {
      parts.push('Alt');
    }

    parts.push(shortcut.key.toUpperCase());

    return parts.join('+');
  }

  async InferenceTest(){
      //const test = await this._infenrenceService.sendMessage();
      //console.debug(test)
  }


    expandChatForContent(): void {
       this._console.log('this.isExpandedForContent = true;')
        this.store.isExpandedForComplexContent.update(()=>true)
    }

    collapseChatAfterContent(): void {
     this._console.log('this.isExpandedForContent = false;')
        this.store.isExpandedForComplexContent.update(()=>false);
    }


  /**
   * Abre el chat (si no está abierto) e inicia la grabación de audio.
   * Usado por el atajo de teclado.
   */
  openAndStartRecording() {
    this._llmLoggingService.info('Intentando abrir chat/iniciar grabación mediante atajo de teclado', {
      isRecording: this.store.isRecording(),
      isShowChat: this.store.isShowChat()
    }, 'MainWdgtComponent', 'openAndStartRecording');

    if (!this.store.isRecording()) {
      //this._speechRecognitionService.startRecognition()
    }
    if (!this.store.isShowChat()) {
      this.store.setShowChat(true);
      this._llmLoggingService.info('Abriendo chat e iniciando grabación', {}, 'MainWdgtComponent', 'openAndStartRecording');
      this._messageService.obterMensagemAleatoria().finally(() => {
        this.audioRecordingService.resumeRecording();
      })
      this.audioRecordingService.startRecording();
      setTimeout(() => this.audioRecordingService.startRecording(), 100);
    } else if (this.store.isShowChat() && !this.store.isRecording()) {
      this._llmLoggingService.info('Iniciando grabación en chat ya abierto', {}, 'MainWdgtComponent', 'openAndStartRecording');
      this.audioRecordingService.startRecording();
    } else if (this.store.isRecording()) {
      this._llmLoggingService.info('Deteniendo grabación por atajo de teclado', {}, 'MainWdgtComponent', 'openAndStartRecording');
      this.audioRecordingService.stopRecording()
      this.store.isProcessingAudio.set(true);
    }
  }
  protected readonly alert = alert;
}
